export default "__VITE_ASSET__Cj4vBuHM__"